/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Apidocs1Inputs */

const id_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentasi API`)
};

const ms_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen API`)
};

const da_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Dokumentation`)
};

const de_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Dokumentation`)
};

const en_us2_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Docs`)
};

const es_es2_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentación de la API`)
};

const es_mx2_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentación de la API`)
};

const fil_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentasyon ng API`)
};

const fr_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doc API`)
};

const it_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentazione API`)
};

const hu_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API dokumentáció`)
};

const nl_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-documentatie`)
};

const no_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-dokumentasjon`)
};

const pl_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentacja API`)
};

const pt_br2_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentação da API`)
};

const pt_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentação da API`)
};

const ro_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentația API`)
};

const fi_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-dokumentaatio`)
};

const sv_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-dokumentation`)
};

const vi_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài liệu API`)
};

const tr_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Dokümanları`)
};

const cs_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentace API`)
};

const bg_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API документация`)
};

const ru_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Документация API`)
};

const uk_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Документація API`)
};

const ar_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وثائق API`)
};

const hi_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API दस्तावेज़`)
};

const th_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เอกสาร API`)
};

const ja_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API ドキュメント`)
};

const zh_cn2_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API文档`)
};

const zh_hant1_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API文件`)
};

const ko_footer_apidocs1 = /** @type {(inputs: Footer_Apidocs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 문서`)
};

/**
* | output |
* | --- |
* | "API Docs" |
*
* @param {Footer_Apidocs1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const footer_apidocs1 = /** @type {((inputs?: Footer_Apidocs1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Apidocs1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_footer_apidocs1(inputs)
	if (locale === "ms") return ms_footer_apidocs1(inputs)
	if (locale === "da") return da_footer_apidocs1(inputs)
	if (locale === "de") return de_footer_apidocs1(inputs)
	if (locale === "en-US") return en_us2_footer_apidocs1(inputs)
	if (locale === "es-ES") return es_es2_footer_apidocs1(inputs)
	if (locale === "es-MX") return es_mx2_footer_apidocs1(inputs)
	if (locale === "fil") return fil_footer_apidocs1(inputs)
	if (locale === "fr") return fr_footer_apidocs1(inputs)
	if (locale === "it") return it_footer_apidocs1(inputs)
	if (locale === "hu") return hu_footer_apidocs1(inputs)
	if (locale === "nl") return nl_footer_apidocs1(inputs)
	if (locale === "no") return no_footer_apidocs1(inputs)
	if (locale === "pl") return pl_footer_apidocs1(inputs)
	if (locale === "pt-BR") return pt_br2_footer_apidocs1(inputs)
	if (locale === "pt") return pt_footer_apidocs1(inputs)
	if (locale === "ro") return ro_footer_apidocs1(inputs)
	if (locale === "fi") return fi_footer_apidocs1(inputs)
	if (locale === "sv") return sv_footer_apidocs1(inputs)
	if (locale === "vi") return vi_footer_apidocs1(inputs)
	if (locale === "tr") return tr_footer_apidocs1(inputs)
	if (locale === "cs") return cs_footer_apidocs1(inputs)
	if (locale === "bg") return bg_footer_apidocs1(inputs)
	if (locale === "ru") return ru_footer_apidocs1(inputs)
	if (locale === "uk") return uk_footer_apidocs1(inputs)
	if (locale === "ar") return ar_footer_apidocs1(inputs)
	if (locale === "hi") return hi_footer_apidocs1(inputs)
	if (locale === "th") return th_footer_apidocs1(inputs)
	if (locale === "ja") return ja_footer_apidocs1(inputs)
	if (locale === "zh-CN") return zh_cn2_footer_apidocs1(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_apidocs1(inputs)
	return ko_footer_apidocs1(inputs)
});
export { footer_apidocs1 as "footer.apiDocs" }